<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.index,
                    },
                    {
                        name: activity.title,
                        href: meta.links.show,
                    },
                    {
                        name: $tc('messages.questions', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex space-x-2">
            <div>
                <aside class="justify-self-center">
                    <nav
                        class="inline-flex items-center justify-center p-1 space-x-1 overflow-hidden text-sm text-gray-600 bg-gray-100 rounded-xl"
                    >
                        <template v-for="link in meta.menu.links" :key="link.url">
                            <template v-if="link.selected">
                                <AppButton :href="link.url" element="inertia-link">
                                    {{ link.display_name }}
                                </AppButton>
                            </template>
                            <template v-else>
                                <InertiaLink
                                    :href="link.url"
                                    class="inline-flex items-center h-8 px-5 font-medium transition rounded-lg hover:text-gray-800 focus:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-inset"
                                >
                                    {{ link.display_name }}
                                </InertiaLink>
                            </template>
                        </template>
                    </nav>
                </aside>
            </div>
        </div>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="table-fixed min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="w-10 max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.title') }}
                                </th>
                                <th
                                    class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.description') }}
                                </th>
                                <th
                                    class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.weight') }}
                                </th>
                                <th
                                    class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.difficulty') }}
                                </th>
                            </tr>
                        </thead>

                        <draggable
                            tag="tbody"
                            v-model="questionsToOrder"
                            group="people"
                            @start="drag = true"
                            @end="drag = false"
                            handle=".handle"
                            @change="reorderQuestions()"
                            item-key="id"
                        >
                            <template #item="{ element: question, index }">
                                <tr :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-100'" :key="index">
                                    <td class="truncate px-6 py-4 text-sm leading-5 text-gray-900">
                                        <div class="flex space-x-2 items-center">
                                            <IconGripVertical
                                                class="handle inline-block h-4 w-4 text-gray-600 cursor-move"
                                            />
                                            <QuestionIcon class="text-gray-400 w-4 h-4" :type="question.type" />
                                            <span class="ml-1">{{ question.title }}</span>
                                        </div>
                                    </td>
                                    <td class="max-w-sm px-6 py-4 text-sm leading-5 font-medium text-gray-500">
                                        <div v-if="question.description">
                                            <QuestionDescriptionDisplay :question="question" />
                                        </div>
                                    </td>
                                    <td class="truncate px-6 py-4 text-sm leading-5 text-gray-900">
                                        {{ question.weight }}
                                        <span class="text-gray-500">({{ question.weight_percent }}%)</span>
                                    </td>
                                    <td class="truncate px-6 py-4 text-sm leading-5 text-gray-900">
                                        <SmallNumberRangeIndicator :max="5" :value="question.difficulty" />
                                    </td>
                                </tr>
                            </template>
                        </draggable>
                    </table>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';
import SmallNumberRangeIndicator from '@/components/SmallNumberRangeIndicator.vue';
import draggable from 'vuedraggable';
import QuestionIcon from '@/components/QuestionIcon.vue';
import { IconGripVertical } from '@tabler/icons-vue';
import QuestionDescriptionDisplay from '@/components/Quiz/QuestionDescriptionDisplay.vue';

export default {
    components: {
        QuestionDescriptionDisplay,
        QuestionIcon,
        PanelPage,
        AppButton,
        SmallNumberRangeIndicator,
        draggable,
        IconGripVertical,
    },
    layout: Layout,
    name: 'Edit',
    props: ['meta', 'questions', 'activity', 'defaults'],
    data() {
        return {
            another: false,
            questionsToOrder: this.questions,
            form: this.$inertia.form({
                doable_days: this.activity.quiz.doable_days,
            }),
        };
    },
    methods: {
        reorderQuestions() {
            const newOrder = this.questionsToOrder.map((s) => s.id);
            this.$inertia.patch(
                this.meta.links.questions_reorder,
                { questions: newOrder },
                {
                    preserveScroll: true,
                },
            );
        },
    },
};
</script>
